import Vue from 'vue'

function LinkCell ({classes='-color-blue-1 link-', text=null, callback=null}) {
  const LinkComponent = Vue.extend({
    template: `<a href="#" class="${classes}" @click="onClick">{{text}}</a>`,
    data () {
      return {
        classes: classes,
        text: text
      }
    },
    methods: {
      onClick (e) {
        e.preventDefault()
        if (callback) {
          callback(this.params)
        }
      }
    },
    beforeMount() {
      this.text = this.text || this.params.value
    }
  })
  return LinkComponent
}

export default LinkCell



// WEBPACK FOOTER //
// ./src/pages/components/ag-grid/LinkCell.js